module.exports = __webpack_public_path__ + "img/img10.da018438.svg";